import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Nav from "@/components/fittin/Nav";
import Hero from "@/components/fittin/Hero";
import ForShoppers from "@/components/fittin/ForShoppers";
import CheckIn from "@/components/fittin/CheckIn";
import ReturnsPillar from "@/components/fittin/ReturnsPillar";
import ConsumerMCP from "@/components/fittin/ConsumerMCP";
import IntegrationDemo from "@/components/fittin/IntegrationDemo";
import SilentUX from "@/components/fittin/SilentUX";
import Footer from "@/components/fittin/Footer";

export default function ShopperPage() {
  const { hash } = useLocation();

  // Support deep links like /#create-fitkey (also used by retired account routes).
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 120);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <main
      data-testid="shopper-page"
      className="relative min-h-screen bg-[#FAFAFA] text-[#0A0A0A] overflow-x-hidden"
    >
      <Nav />
      <Hero variant="shopper" />
      <ForShoppers />
      <CheckIn />
      <ReturnsPillar />
      <ConsumerMCP />
      <IntegrationDemo />
      <SilentUX />
      <Footer />
    </main>
  );
}
